// extracted by mini-css-extract-plugin
export default {"bannerControl":"Profile_bannerControl__UbpH1"};